module.exports = __webpack_public_path__ + "static/26-5c5f93fe17d16a26b090399ddec0c1bb.png";